import globalValues from '@/core/helpers/enums/globalValues';
import { http } from '@/utils/http.util';

export default class submissionService {
   async postSubmission(submission: Object) {
      return await http
         .post('/api/submission', submission)
         .then((response) => {
            if (response.status && response.data) {
               return response.data;
            } else {
               throw Error(`Registratie is niet gelukt`);
            }
         })
         .catch((error) => {
            if (error?.response?.status === 422 && error?.response?.data && error?.response?.data?.message) {
               throw Error(error.response.data.message);
            } else {
               throw Error(`Registratie is niet gelukt`);
            }
         });
   }
   async patchSubmission(body: Object) {
      const submissionRandom = sessionStorage.getItem(globalValues.candidate.journeyRandom);
      return await http.patch(`/api/submission/${submissionRandom}`, body).then((response) => {
         return response.data;
      });
   }
   async putSubmission(body: Object) {
      const submissionRandom = sessionStorage.getItem(globalValues.candidate.journeyRandom);
      return await http.put(`/api/submission/${submissionRandom}`, body).then((response) => {
         return response.data;
      });
   }
}

